// import React, { useEffect } from "react";

// const AdsComponent = (props) => {
//   const { dataAdSlot } = props;

//   useEffect(() => {
//     try {
//       (window.adsbygoogle = window.adsbygoogle || []).push({});
//     } catch (e) {}
//   }, []);

//   return (
//     <>
//       <div>
//         <ins
//           className="adsbygoogle"
//           style={{ display: "block", height: "auto" }}
//           data-ad-client="ca-pub-2178006875471084"
//           data-ad-slot={dataAdSlot || "6034632442"}
//           data-ad-format="on"
//           data-full-width-responsive="true"
//         ></ins>
//       </div>
//     </>
//   );
// };

// export default AdsComponent;

// import React, { useEffect, useState } from "react";

// const AdsComponent = ({ dataAdSlot }) => {
//   const [adError, setAdError] = useState(null);
//   const [adLoaded, setAdLoaded] = useState(false);

//   useEffect(() => {
//     const handleAdLoad = () => {
//       setAdLoaded(true);
//     };

//     const loadAd = () => {
//       try {
//         if (!window.adsbygoogle) {
//           const script = document.createElement("script");
//           script.src =
//             "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
//           script.async = true;
//           script.onload = () => {
//             window.adsbygoogle = window.adsbygoogle || [];
//             window.adsbygoogle.push({});
//             setTimeout(handleAdLoad, 500);
//           };
//           script.onerror = () => setAdError("Failed to load AdSense script");
//           document.body.appendChild(script);
//         } else {
//           window.adsbygoogle.push({});
//           setTimeout(handleAdLoad, 500);
//         }
//       } catch (e) {
//         setAdError(e.message);
//       }
//     };

//     loadAd();

//     return () => {
//       setAdError(null);
//       setAdLoaded(false);
//     };
//   }, [dataAdSlot]);

//   const adSlot = dataAdSlot || "7923150994";

//   return (
//     <div style={{ minHeight: "90px", padding: "10px" }}>
//       {adError ? (
//         <div style={{ color: "gray", fontStyle: "italic" }}>
//           Ad could not be loaded.
//         </div>
//       ) : !adLoaded ? (
//         <div
//           style={{
//             height: "100px",
//             width: "100%",
//             border: "2px dashed #ccc",
//             backgroundColor: "#f5f5f5",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             color: "#666",
//             fontSize: "16px",
//           }}
//         >
//           Ad
//         </div>
//       ) : null}

//       <ins
//         className="adsbygoogle"
//         style={{ display: adLoaded ? "block" : "none" }}
//         data-ad-client="ca-pub-2178006875471084"
//          data-ad-slot={adSlot}
//         data-ad-format="auto"
//         data-full-width-responsive="true"
//       />
//     </div>
//   );
// };

// export default AdsComponent;

import React, { useEffect, useState } from "react";

const AdsComponent = (props) => {
  const { dataAdSlot = "6034632442" } = props; // Default value if not provided
  const [adLoaded, setAdLoaded] = useState(false);

  useEffect(() => {
    if (adLoaded || !window.adsbygoogle) return;

    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
      setAdLoaded(true);
    } catch (e) {
      console.error("Ad load error:", e);
    }
  }, [adLoaded]);

  return (
    <div
      style={{
        minHeight: adLoaded ? "auto" : "250px",
        position: "relative",
      }}
    >
      {!adLoaded && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#666",
            textAlign: "center",
            marginTop :"10px",
          }}
        >
          ..........
        </div>
      )}
      <ins
        className="adsbygoogle"
        style={{
          display: "block",
          minHeight: "250px",
          width: "100%",
        }}
        data-ad-client="ca-pub-2178006875471084"
        data-ad-slot={dataAdSlot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdsComponent;
